import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import Footer from '../common/footer'
import Logo from '../common/logo'
import AssessmentJPMC from './assessment_jpmc'
import moment from 'moment'

class Assessment extends Component {
  constructor(props) {
    super(props)
    this.nextPage = this._nextPage.bind(this)
    document.title = "Newtopia"
  }

  async _nextPage() {
    return this.props.next()
  }

  extendRoute(R) {
    return props => (
      <R 
        {...props} 
        next={this.nextPage}
      />
    )
    }

  header() {
    return (
      <div className="container header">
        <Logo />
      </div>
    )
  }

  footer() {
    const todayDate = moment()
    return (
      <div>
        <hr className="footer-separator" />
        <Footer />
        <div className="extra-screener-footer container">
          <p className="extra-footer-info">© {todayDate.format('YYYY')} NEWTOPIA INC. </p>
          <p className="extra-footer-info">The Newtopia program requires you to complete a personal profile. There is a question in the profile that asks about your family medical history (the family medical history question is marked as "voluntary" in the profile). Completion of this question, as well as providing a genetic (saliva) test sample, is strictly voluntary. If you choose to provide family medical history in the personal profile or provide a genetic (saliva) test sample, your authorization to process the genetic (saliva) test sample and/or analyze your family medical history is included in the Newtopia Genetics Consent Agreement that you will be asked to agree to on the following screen. That Agreement also describes confidentiality protections and restrictions on the use and disclosure of your genetic information.</p>
        </div>
      </div>
    )
  }
  
  render() {
    return (
      <div id="screener">
        <Router basename={this.props.match.path}>
          <div>
            <Route component={this.header}/>
            <Switch>
              <Route render={this.extendRoute(AssessmentJPMC)} />
            </Switch>
            <Route path="/2" component={this.footer}/>
          </div>
        </Router>
      </div>
    )
  }
}

export default Assessment